import React, { useState } from "react";
import TabbedViewWithDateSelect from "../../components/TabbedViewWithDateSelect/TabbedViewWithDateSelect";
import { JLR_PLANT } from "../../constants";
import { usePlantAndLinesStore } from "../../providers/PlantAndLinesStore/PlantAndLinesStore";
import MasterShift from "../MasterShift/MasterShift";

const ShiftConfigurator = () => {
  const [plant] = usePlantAndLinesStore().plantState;
  const [MasterCount, setMasterCount] = useState(0);

  const title = "Shift Configurator";

  return (
    <div>
      <TabbedViewWithDateSelect
        tabs={[
          {
            label: "Master Shift",
            title: "Master Shift",
            count: MasterCount,
            countColor: plant.label === JLR_PLANT ? 'green' : 'blue',
            backgroundColor: plant.label === JLR_PLANT ? 'green' : 'blue',
            component: MasterShift,
            props: {
              handleCountChange: setMasterCount,
            },
          },
        ]}
        pageTitle={title}
      />
    </div>
  );
};

export default ShiftConfigurator;
